import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// import { getUserInfo, UserInfo } from '../api/launchTrackerApi'
import { AppThunk } from "../app/store";
import { getUser } from "../app/api";
import { Requester } from "../../server/asin-central/model";

interface UserInfoState {
  userName: string;
  isLoading: boolean;
  error: string | null;
  featureFlags: {
    loomAgentAssistantEnabled: boolean;
  };
}

const userInfoInitialState: UserInfoState = {
  userName: "",
  isLoading: true,
  error: null,
  featureFlags: {
    loomAgentAssistantEnabled: false,
  },
};

const userInfo = createSlice({
  name: "userInfo",
  initialState: userInfoInitialState,
  reducers: {
    getUserInfoStarted(state) {
      state.isLoading = true;
    },
    getUserInfoSuccess(
      state,
      action: PayloadAction<{
        userName: string;
        featureFlags?: { loomAgentAssistantEnabled: boolean };
      }>
    ) {
      state.userName = action.payload.userName;
      state.featureFlags.loomAgentAssistantEnabled =
        action.payload.featureFlags?.loomAgentAssistantEnabled ?? false;
      state.isLoading = false;
      state.error = null;
    },
    getUserInfoFailure(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { getUserInfoStarted, getUserInfoSuccess, getUserInfoFailure } =
  userInfo.actions;

export default userInfo.reducer;

export const fetchUserInfo = (): AppThunk => async (dispatch) => {
  try {
    dispatch(getUserInfoStarted());
    const requester: Requester = await getUser();
    dispatch(
      getUserInfoSuccess({
        userName: requester.requester.identity,
        featureFlags: (requester as any).featureFlags,
      })
    );
  } catch (err: any) {
    dispatch(getUserInfoFailure(err.toString()));
  }
};

export const selectUserName = (state: any) => state.userInfo.userName;

export const selectIsLoomAgentAssistantEnabled = (state: any) =>
  state.userInfo.featureFlags.loomAgentAssistantEnabled;
